var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryMobileServices = function SvgCategoryMobileServices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "category_mobile_services_svg__Layer_3_1_",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".category_mobile_services_svg__st0{fill:none;stroke:#666;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_services_svg__st0",
    d: "M24.5 15.3h4.2c.5 0 1 .2 1.4.6l.3.3c.2.3.4.6.4 1v.4c0 .5.1.8.5 1l1.7 1.5c.5.4.7.9.7 1.4v7.3c0 .5-.1 1-.5 1.4h0c-.1.2-.5.3-.7.3h-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_services_svg__st0",
    d: "m30.8 18.1-3.1 3.5-1.8-3.5 4-2.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_services_svg__st0",
    d: "m24.5 33.4 2.6-2.9-1.4-8.7 1.3-1.7M24.5 15.3h-4.2c-.5 0-1 .2-1.4.6l-.3.3c-.2.3-.4.6-.4 1v.4c0 .5-.1.8-.5 1L16 20.1c-.5.4-.7.9-.7 1.4v7.3c0 .5.1 1 .5 1.4h0c.2.2.5.3.7.3h5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "category_mobile_services_svg__st0",
    d: "m18.2 18.1 3 3.5 1.8-3.5-3.9-2.3M24.5 33.4l-2.7-2.9 1.5-8.7-1.3-1.7M25.9 18.1H23M23.3 21.8h2.4"
  })));
};
export default SvgCategoryMobileServices;